/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Figure_AltInputs */

const en_gc_search_guides_what_is_gridcraft_sections_1_figure_alt = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Figure_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft formula workspace showing a gradebook and function tools`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_1_figure_alt = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Figure_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 公式工作区，显示成绩表和函数工具`)
};

/**
* | output |
* | --- |
* | "GridCraft formula workspace showing a gradebook and function tools" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Figure_AltInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_1_figure_alt = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Figure_AltInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Figure_AltInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_1_figure_alt(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_1_figure_alt(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_1_figure_alt as "gc.search_guides.what_is_gridcraft.sections.1.figure.alt" }